module.exports = __webpack_public_path__ + "img/check-game-over.e543c36c.png";